import React from 'react';
import PropTypes from 'prop-types';
import { MenuItemContainer } from '@metarouter-private/mr-mui';
import IntegrationAvatarAndName from 'app/shared/components/integrations/IntegrationAvatarAndName';

const STATIC_PROPS = {
  AvatarProps: {
    size: 'xs',
  },
  TypographyProps: {
    ellipsis: true,
  },
};

export default function PipelineIntegrationMenuItem({ pipelineIntegration: { integration } }) {
  return (
    <MenuItemContainer>
      <IntegrationAvatarAndName {...STATIC_PROPS} integration={integration} />
    </MenuItemContainer>
  );
}

PipelineIntegrationMenuItem.propTypes = {
  pipelineIntegration: PropTypes.shape({
    integration: PropTypes.shape({
      starterkitId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }),
};
